//@flow
import * as Immutable from 'immutable';

import { LocationCrossDockInfo } from 'common/models/flow/LocationCrossDockInfo';
import type { LocationCrossDockInfoModelType } from 'common/models/flow/LocationCrossDockInfo';

import { HomebaseId } from './HomebaseId';
import { MasterHomebase } from './MasterHomebase';
import { validatable } from 'common/utils/ValidationUtil';

@validatable
class InternalLocationCrossDockInfo extends LocationCrossDockInfo {
    static fromJS(
        json: LocationCrossDockInfoModelType
    ): InternalLocationCrossDockInfo {
        const state: Object = Object.assign({}, json);
        state.crossDockIds = Immutable.List(state.crossDockIds).map(item =>
            HomebaseId.fromJS(item)
        );
        state.crossDocks = Immutable.List(state.crossDocks).map(item =>
            MasterHomebase.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    sanitize(): this {
        return this.setCrossDocks(Immutable.List());
    }

    defaultSanitize(): this {
        return this.setCrossDocks(Immutable.List());
    }
}

export { InternalLocationCrossDockInfo as LocationCrossDockInfo };
